import { BaseModel } from "sjs-base-model";

export default class PreventiviConFirmaDigitaleModel extends BaseModel {
    public readonly idEstimate: number | undefined;
    public readonly idEstimateRequest: number | undefined;
    public readonly customerName: string = "";
    public readonly customerSurname: string = "";
    public readonly latestSignedDate: string = "";

    constructor(data: Partial<PreventiviConFirmaDigitaleModel>) {
        super();

        this.update(data);
    }
}
